import type { AuthUser, LoginRequest, RegisterRequest } from '@libellus/shared';
import { createContext, useContext } from 'react';

export type Session =
  { status: 'loading' } | { status: 'signedOut' } | { status: 'signedIn'; user: AuthUser };

export interface SessionContextValue {
  session: Session;
  signIn: (credentials: LoginRequest) => Promise<void>;
  signUp: (details: RegisterRequest) => Promise<void>;
  signOut: () => Promise<void>;
}

export const SessionContext = createContext<SessionContextValue | null>(null);

export function useSession(): SessionContextValue {
  const value = useContext(SessionContext);
  if (!value) throw new Error('useSession must be used inside <SessionProvider>');
  return value;
}

/** For screens behind the guard, where a signed-in user is guaranteed. */
export function useCurrentUser(): AuthUser {
  const { session } = useSession();
  if (session.status !== 'signedIn') throw new Error('No signed-in user');
  return session.user;
}
